import React from 'react';
import { PageContext } from '../providers/PageContextProvider';

const usePageContext = () => React.useContext(PageContext);

export default usePageContext;
